import { CloseBoxOutlineIcon } from './CloseBoxOutlineIcon';

/**
 * author: Gabriel
 * id 05B8E566-B224-4ECC-AE70-2BF8BE90C82A
 * name close-box-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/close-box-outline.svg
 * tags
 * - Math 
 * - Form 
 */
export const ClearBoxOutlineIcon = CloseBoxOutlineIcon;
export default ClearBoxOutlineIcon